import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { ChevronRight } from "@root/assets/icons/chevron-right";
import { useRiskAssessmentContext } from "@root/context/risk-assessment-context";
import { AI_MODEL_OPTIONS, ROUTE_NAMES } from "@root/constants";
import { useLocation } from "react-router-dom";

export const SuggestedQueryChips = ({
  suggestedQuestions,
  onSubmitHandler,
}: any) => {
  const {
    suggestedQuestionsLoading,
    setSelectedAskAiModel,
    setSelectedMultiAiModel,
  } = useRiskAssessmentContext();
  const { pathname } = useLocation();

  const renderSuggestedQuestions = () => {
    if (suggestedQuestionsLoading) return <Spinner />;
    return (
      <Flex
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        gap={"12px"}
      >
        {(() => {
          const items = suggestedQuestions?.slice?.(0, 5) || [];
          const rows: any[] = [];
          for (let i = 0; i < items.length; i += 2) {
            rows?.push(items?.slice(i, i + 2));
          }
          return rows?.map((row: any[], rowIndex: number) => (
            <Flex key={rowIndex} gap={"12px"}>
              {row?.map((item: any, chipIndex: number) => (
                <Box
                  key={`${rowIndex}-${chipIndex}`}
                  p="2px"
                  borderRadius="56px"
                  background="linear-gradient(270deg, rgba(255, 255, 255, 0.9) 0%, rgba(177, 89, 6, 0.9) 22.6%, rgba(0, 94, 184, 0.9) 100%)"
                  onClick={() => {
                    // Find the model by ID and select it
                    const modelToSelect = AI_MODEL_OPTIONS.find(
                      (model) => model?.id === item?.modelType
                    );

                    if (modelToSelect) {
                      // Determine which model to set based on current route
                      if (pathname?.includes(ROUTE_NAMES?.MULTI_AI_CHATBOT))
                        setSelectedMultiAiModel?.(modelToSelect);
                      else if (pathname?.includes(ROUTE_NAMES?.ASK_AI_CHATBOT))
                        setSelectedAskAiModel?.(modelToSelect);
                    }

                    // Submit the query directly - onSubmitHandler handles the input parameter
                    onSubmitHandler(item?.question, item?.modelType);
                  }}
                >
                  <Flex
                    px="16px"
                    py="12px"
                    cursor="pointer"
                    alignItems="center"
                    gap="8px"
                    borderRadius="56px"
                    bg="white"
                    _hover={{
                      bg: "#F5F7FF",
                    }}
                    transition="all 0.2s"
                  >
                    <Text
                      fontSize="14px"
                      fontWeight="500"
                      color="#2D3748"
                      flex="1"
                    >
                      {item?.question}
                    </Text>
                    <ChevronRight width="16px" height="16px" color="#6B7280" />
                  </Flex>
                </Box>
              ))}
            </Flex>
          ));
        })()}
      </Flex>
    );
  };

  return (
    <Flex alignItems={"center"} justifyContent={"center"}>
      {/* Suggested Query Chips */}
      {renderSuggestedQuestions()}
    </Flex>
  );
};

export default SuggestedQueryChips;
